<template>
    <div class="pt-2 pl-2">
        <v-row no-gutters>
            <v-col cols="8" class="pr-1">
                <v-card class="default_card_wm elevation-0 pt-2" style="height: 90vh">
                    <v-row no-gutters>
                        <v-col cols="2">
                            <v-btn-back
                                @click.stop="back()"
                                v-if="mode !== 'GeneralLedger' && goBackHistory"
                                data-cy="document-back"
                            />
                        </v-col>
                        <v-col cols="8" class="d-flex justify-end">
                            <v-slider
                                v-model="pagesPerRow"
                                label="Pages par ligne"
                                :max="4"
                                :min="1"
                                step="1"
                                hide-details
                                tick-size="4"
                                show-ticks
                            />
                        </v-col>
                        <v-col cols="2" class="d-flex justify-end">
                            <v-menu offset-y>
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon icon="$dots_vertical" v-bind="props" class="mx-1" />
                                </template>
                                <v-list nav rounded="xl">
                                    <v-list-item @click="analyseDocument" v-if="enableAnalysis">
                                        <v-list-item-title>Lancer l'analyse</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon>$oss-scan</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        @click="startDownloadFile"
                                        v-if="document.signedUrl"
                                    >
                                        <v-list-item-title
                                            >Télécharger le document</v-list-item-title
                                        >
                                        <template v-slot:append>
                                            <v-icon>$oss-download</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        :disabled="disabledDelete"
                                        @click="deleteDocumentDialog = true"
                                        color="error"
                                        :active="!disabledDelete"
                                    >
                                        <v-list-item-title>Supprimer</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-trash</v-icon>
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>
                        <v-col
                            cols="12"
                            class="d-flex justify-center"
                            @mouseover="onZoneIn()"
                            @mouseout="onZoneOut()"
                        >
                            <v-row
                                no-gutters
                                class="d-flex"
                                :class="loading ? 'justify-center' : 'd-flex justify-start'"
                                style="max-height: 83vh; overflow-y: auto"
                            >
                                <v-col cols="12" class="d-flex justify-center">
                                    <v-progress-circular :size="50" indeterminate v-if="loading" />
                                </v-col>
                                <v-col cols="1" v-show="false" v-if="src">
                                    <pdf :source="src" @loaded="loaded"> </pdf>
                                </v-col>
                                <draggable
                                    v-model="pages"
                                    tag="div"
                                    class="py-1 no-gutters draggable-main d-flex"
                                    :class="loading ? 'justify-center' : 'justify-start'"
                                    @start="onDragStart"
                                    @end="onDragEnd"
                                >
                                    <template #item="{ element, index }">
                                        <v-col
                                            :cols="pdfCol"
                                            :key="index"
                                            @click="split(index)"
                                            @mouseover="onPageOver(element, index)"
                                            @mouseout="onMouseLeave(element)"
                                            class="draggable-col"
                                        >
                                            <div
                                                class="draggable-col-div"
                                                :style="getBorder(index, element.hover)"
                                            >
                                                <DocumentPDF
                                                    :ref="'pdf' + index"
                                                    v-if="element.display"
                                                    :id="index + ''"
                                                    :srcImport="src"
                                                    :page="element.index"
                                                    :rotate="element.direction"
                                                    :resize="true"
                                                    :scrollWheelZoomAvailable="false"
                                                    style="width: 100%"
                                                    :class="
                                                        element.remove
                                                            ? 'hover'
                                                            : isInside(index)
                                                              ? ''
                                                              : 'hover'
                                                    "
                                                >
                                                    <template #loading>
                                                        Chargement en cours
                                                    </template>
                                                </DocumentPDF>
                                                <v-overlay
                                                    v-model="element.hover"
                                                    opacity="0"
                                                    class="align-center justify-center"
                                                    contained
                                                    :absolute="true"
                                                >
                                                    <v-btn-trash
                                                        size="x-small"
                                                        class="my-0 mr-1"
                                                        @click.stop="removePage(index)"
                                                    >
                                                    </v-btn-trash>
                                                    <v-btn
                                                        size="x-small"
                                                        class="my-0 mr-1"
                                                        @click.stop="
                                                            rotatePage('left', element, index)
                                                        "
                                                        icon="$fa-undo"
                                                    >
                                                    </v-btn>
                                                    <v-btn
                                                        size="x-small"
                                                        class="my-0"
                                                        @click.stop="
                                                            rotatePage('right', element, index)
                                                        "
                                                        icon="$fa-redo"
                                                    >
                                                    </v-btn>
                                                    <v-btn
                                                        size="x-small"
                                                        class="my-0"
                                                        icon="$oss-zoom-in"
                                                        @click.stop="openZoomDialog(index)"
                                                    >
                                                    </v-btn>
                                                </v-overlay>
                                                <v-btn
                                                    :variant="
                                                        !isEndPage(index) && element.hover
                                                            ? 'outlined'
                                                            : 'flat'
                                                    "
                                                    size="x-small"
                                                    class="split"
                                                    v-if="
                                                        index < pageCount &&
                                                        (isEndPage(index) || element.hover)
                                                    "
                                                    icon="$fa-cut"
                                                />
                                            </div>
                                        </v-col>
                                    </template>
                                </draggable>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="4" class="my-0 pl-1">
                <v-card
                    style="
                        border-top-right-radius: 0px !important;
                        border-bottom-right-radius: 0px !important;
                        overflow: hidden;
                    "
                    class="default_card_wm fill-height elevation-0 rounded-l-2"
                >
                    <v-card-text>
                        <v-list single-line class="pt-0" density="compact">
                            <v-list-item :ripple="false" class="oss-list-item mb-2" color="success">
                                <v-list-item-title class="body-1">
                                    <v-row no-gutters>
                                        <v-col
                                            cols="3"
                                            class="d-flex align-center"
                                            style="border-right: 1px #ededed solid"
                                        >
                                            <b>Statut</b>
                                        </v-col>
                                        <v-col cols="9" class="d-flex align-center pl-2">
                                            {{ documentStatus || "inconnu" }}
                                            <v-spacer />
                                            <v-btn
                                                rounded
                                                elevation="0"
                                                v-if="
                                                    activateReconciliation &&
                                                    reconciliationCallToAction &&
                                                    mode !== 'Reconciliation'
                                                "
                                                :disabled="disabledCallToAction"
                                                @click="openReconciliation()"
                                                size="small"
                                                >{{ reconciliationCallToAction }}</v-btn
                                            >
                                        </v-col>
                                    </v-row>
                                </v-list-item-title></v-list-item
                            >
                        </v-list>
                        <v-list style="height: 72vh; overflow: auto">
                            <v-list-item
                                v-for="(item, index) in pageRanges"
                                :key="index"
                                class="py-0 px-0"
                                @mouseover="onZoneIn()"
                                @mouseout="onZoneOut()"
                            >
                                <v-row
                                    no-gutters
                                    @mouseover="onMouseOver(item)"
                                    @mouseleave="onMouseLeave(item)"
                                    class="pt-1"
                                >
                                    <v-col class="pl-2" cols="5">
                                        <v-row no-gutters>
                                            <v-col cols="12" class="font-weight-bold">
                                                Document {{ index + 1 }}
                                            </v-col>
                                            <v-col cols="12" class="pt-1">
                                                De la page {{ item.start + 1 }} à
                                                {{ item.end + 1 }}
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col class="pl-2" cols="5">
                                        <v-select-filled
                                            v-model="item.type"
                                            :items="documentTypes"
                                            outlined
                                            hide-details
                                            density="compact"
                                            item-title="text"
                                        />
                                    </v-col>
                                    <v-col cols="2" class="d-flex align-center justify-center">
                                        <v-btn-trash
                                            @click="split(item.end)"
                                            v-if="index < pageRanges.length - 1"
                                            size="small"
                                        />
                                    </v-col>
                                    <v-col cols="12" class="pt-1">
                                        <v-divider />
                                    </v-col> </v-row
                            ></v-list-item>
                        </v-list>
                    </v-card-text>
                    <v-card-actions>
                        <v-row no-gutters>
                            <v-col cols="12" class="d-flex justify-end">
                                <v-tooltip
                                    v-if="selectedCompany.solution !== 'MANAGEMENT'"
                                    location="top"
                                >
                                    <template v-slot:activator="{ props }">
                                        <v-btn-warning
                                            size="x-small"
                                            @click="setOpenChat('DENIED')"
                                            class="mr-1"
                                            :disabled="inDocument.status === 'DENIED'"
                                            v-bind="props"
                                        >
                                        </v-btn-warning>
                                    </template>
                                    <span>Rejeter</span>
                                </v-tooltip>
                                <v-tooltip
                                    v-if="selectedCompany.solution !== 'MANAGEMENT'"
                                    location="top"
                                >
                                    <template v-slot:activator="{ props }">
                                        <v-btn-icon
                                            @click="setOpenChat('INFORMATION_REQUEST')"
                                            class="mx-1"
                                            size="x-small"
                                            v-bind="props"
                                            icon="$oss-chat"
                                        >
                                        </v-btn-icon>
                                    </template>
                                    <span>Question</span>
                                </v-tooltip>

                                <v-btn
                                    class="mx-1"
                                    :loading="splitLoading"
                                    @click="dialog = true"
                                    :disabled="inDocument.status === 'DENIED'"
                                    size="small"
                                    >Découper</v-btn
                                >

                                <v-btn-prev
                                    :disabled="previousDisabled()"
                                    @click="previous()"
                                    v-if="mode != 'GeneralLedger' && mode !== 'Reconciliation'"
                                />
                                <v-btn-next
                                    :disabled="nextDisabled()"
                                    @click="next()"
                                    v-if="mode != 'GeneralLedger' && mode !== 'Reconciliation'"
                                />
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Chat
            v-if="openChat"
            v-bind:id="inDocument.chat ? inDocument.chat.id : ''"
            v-bind:inShowMessage="open_chat"
            v-bind:chatTitle="'Document'"
            v-bind:chatSubtitle="getChatSubTitle()"
            :showSmartChat="wishStatus !== 'DENIED'"
            @messageSent="onMessageSent($event)"
            @showMessageChanged="onShowMessageChanged($event)"
        />
        <oss-dialog
            v-model="dialog"
            title="Découper le document"
            :validLoading="splitLoading"
            @valid="splitDocument()"
            width="50vw"
        >
            {{
                inDocument.status === "VALIDATED"
                    ? "Attention : les documents générés précédement seront supprimés."
                    : "Validez pour générer le(s) document(s)."
            }}
        </oss-dialog>
        <oss-dialog
            v-model="deleteDocumentDialog"
            title="Supprimer le document"
            :error="true"
            @valid="deleteDocument"
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="deleteDocumentLoading"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer le document ?</h4>
        </oss-dialog>
        <oss-dialog
            v-model="pdfDialog"
            title="Document PDF"
            :validLoading="splitLoading"
            width="50vw"
        >
            <DocumentPDF
                :srcImport="src"
                :page="pageViewed"
                :rotate="rotate"
                :scrollWheelZoomAvailable="true"
            >
            </DocumentPDF>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import Chat from "../chat/Chat.vue";

import pdf from "vue-pdf-embed";
import gql from "graphql-tag";
import _ from "lodash";

import draggable from "vuedraggable";
import { DocumentBase } from "./DocumentBase";
import DocumentPDF from "./DocumentPDF.vue";
import { Component, Vue, toNative, Watch } from "vue-facing-decorator";

@Component({
    components: {
        draggable,
        pdf,
        DocumentPDF,
        Chat,
    },
})
export class DocumentPdfSplitter extends DocumentBase {
    pageCount = 0;
    loadings = [];
    pagesPerRow = 4;

    hover: boolean = false;

    mouseover = {
        start: 0,
        end: 0,
    };

    loading: boolean = false;
    splitLoading: boolean = false;

    dialog = false;
    pageViewed: number = 1;
    pageRanges: any = [];

    pages: any = [];
    pdfDialog: any;

    get pdfCol() {
        switch (this.pagesPerRow) {
            case 1:
                return 12;
            case 2:
                return 6;
            case 3:
                return 4;
            case 4:
                return 3;
            default:
                return 12;
        }
    }

    get endsPagesDocuments() {
        return this.pageRanges.map((x) => x.end);
    }

    get startsPagesDocuments() {
        return this.pageRanges.map((x) => x.start);
    }

    /**
     * Types used for select list for split documents
     */
    documentSplitDocumentTypes: readonly string[] = [
        "PURCHASE_INVOICE",
        "CURRENT_ACCOUNT",
        "EXPENSE_REPORT",
        "SALES_INVOICE",
        "ZTILL_RECEIPT",
        "MISCELLANEOUS",
        "BANK_STATEMENT",
    ];

    get documentTypes() {
        return this.documentSplitDocumentTypes.map((type) => ({
            text: this.$t(`document.type.${type}`),
            value: type,
        }));
    }

    draggedElementIndex: number | null = null; // To track the dragged element index

    /**
     * Handles the drag start event
     *
     * @param {any} event - drag event
     * @property {number} event.oldIndex - The original index of the dragged element (returned by draggable)
     *
     * Takes index of dragged element and returns it in this.draggedElementIndex
     */
    onDragStart(event: any) {
        this.draggedElementIndex = event.oldIndex; // Capture the original index
    }

    /**
     * Handles the drag end event for reordering pages
     *
     * @param {any} event - drag operation event
     *
     * This method updates the page property of the dragged element to reflect its new position
     */
    onDragEnd(event: any) {
        if (this.draggedElementIndex !== null) {
            const movedElement = this.pages[this.draggedElementIndex];
            const newIndex = event.newIndex;

            // Only update the dragged element's page property
            movedElement.page = newIndex + 1;

            // Reset the draggedElementIndex
            this.draggedElementIndex = null;
        }
    }

    mounted() {
        // DO NOT REMOVE LINE BELOW
        this.document = this.inDocument;
        this.prevNextSmartQuery();
        this.initializeUserActivity();
    }

    openZoomDialog(index: number) {
        this.pageViewed = index + 1;
        this.pdfDialog = true;
    }

    @Apollo({
        query() {
            return gql`
                query getDocument($id: ID!) {
                    document(where: { id: $id }) {
                        id
                        status
                        originalSignedUrl
                        original {
                            id
                            key
                        }
                    }
                }
            `;
        },
        variables() {
            // debugger
            return {
                id: this.documentId,
            };
        },
        skip() {
            // debugger
            return !this.documentId || !this.inDocument;
        },
        async specificResult({ data, loading }: any) {
            if (!loading) {
                if (data && data.document) {
                    this.loading = true;
                    const uri = data.document.originalSignedUrl;
                    const response = (await fetch(uri)).body as ReadableStream;
                    this.src = new Uint8Array(await new Response(response).arrayBuffer());
                    this.loading = false;
                }
            }
        },
    })
    src = "";

    get enableAnalysis() {
        if (this.inDocument) {
            return (
                this.inDocument.status === "ORIGINAL_UPLOADED" ||
                this.inDocument.status.startsWith("ANALYSED")
            );
        }
        return (
            this.inDocument.status === "ORIGINAL_UPLOADED" ||
            this.inDocument.status.startsWith("ANALYSED")
        );
    }

    split(index) {
        if (index + 1 === this.pageCount) {
            debugger;
        } else if (this.isEndPage(index)) {
            const toDeleteIndex = this.pageRanges.findIndex((x) => x.end === index);
            const startPage = this.pageRanges[toDeleteIndex].start;
            this.pageRanges = this.pageRanges.filter((obj) => obj.end !== index);
            this.pageRanges[toDeleteIndex].start = startPage;
        } else if (index > this.pageRanges[this.pageRanges.length - 1].start) {
            this.pageRanges[this.pageRanges.length - 1].end = index;
            this.pageRanges.push({
                start: index + 1,
                end: this.pageCount - 1,
                type: "PURCHASE_INVOICE",
            });
        } else {
            const pageRangeIndex = this.pageRanges.findIndex((x) => x.end > index);
            const pageRange = { ...this.pageRanges[pageRangeIndex] };
            this.pageRanges[pageRangeIndex].end = index;
            this.pageRanges.push({
                start: index + 1,
                end: pageRange.end,
                type: "PURCHASE_INVOICE",
            });
            this.pageRanges = _.orderBy(this.pageRanges, ["start", "end"], ["asc", "asc"]);
        }
    }

    // OK
    isEndPage(index) {
        return this.endsPagesDocuments.findIndex((x) => x === index) !== -1;
    }

    // OK
    isStartPage(index) {
        return this.startsPagesDocuments.findIndex((x) => x === index) !== -1;
    }

    // OK
    getSplitColor(index, hover) {
        if (this.isEndPage(index)) {
            return "#F9B12A";
        }
        if (hover) {
            return "#F9B12AAA";
            //     return "border-right: 2px dashed #F9B12A;"
        }
        return "transparent";
    }

    back() {
        this.$router.go(-1);
    }

    refreshTimeout = null;

    //  OK
    isInside(i) {
        if (this.inZone) {
            return this.mouseover && this.mouseover.start <= i && this.mouseover.end >= i;
        }
        return true;
    }

    onMouseOver(item) {
        if (this.refreshTimeout) {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }
        this.mouseover = item;
    }

    // OK
    onPageOver(page, i) {
        page.hover = true;
        this.onMouseOver(this.pageRanges.find((x) => x.start <= i && x.end >= i));
    }

    onMouseLeave(page) {
        page.hover = false;
        this.refreshTimeout = setTimeout(() => {
            this.mouseover = {
                start: 0,
                end: 0,
            };
        }, 100);
    }

    async splitDocument() {
        this.splitLoading = true;
        await this.$apollo.mutate({
            mutation: gql`
                mutation ($id: ID!, $pageRanges: Json!, $pages: Json) {
                    splitDocument(
                        where: { id: $id }
                        data: { pageRanges: $pageRanges, pages: $pages }
                    ) {
                        id
                    }
                }
            `,
            variables: {
                id: this.documentId,
                pageRanges: this.pageRanges,
                pages: this.pages,
            },
        });
        this.splitLoading = false;
        this.dialog = false;
        this.$router.push({
            name: "documents",
        });
    }

    test(data) {
        this.pages[data].loading = false;
    }

    /**
     * Rotates the page in the correct PDF component.
     * @param direction The direction to rotate the page.
     * @param page The page to rotate.
     * @param index The index of the pdf component.
     */
    rotatePage(direction, page, index) {
        const pdfComponent = this.$refs[`pdf${index}`] as any;

        //We make sure we have the component
        if (pdfComponent) {
            switch (direction) {
                case "right":
                    page.direction = (page.direction - 90) % 360;
                    break;
                case "left":
                    page.direction = (page.direction + 90) % 360;
                    break;
            }
        }
    }

    getBorder(i, hover) {
        if (!this.inZone) {
            return "border: solid 2px transparent;";
        }
        if (!this.isInside(i)) {
            return this.getHoverBorderStyle(hover);
        }

        const { row, col } = this.getRowCol(i);
        const { firstRow, firstCol, lastRow, lastCol } = this.getMouseoverRowCol();

        return this.getBorderStyle(row, col, firstRow, firstCol, lastRow, lastCol, hover);
    }

    getHoverBorderStyle(hover) {
        if (hover) {
            return `
                border-top: solid 2px transparent;
                border-right: dotted 2px #F9B12AAA;
                border-bottom: solid 2px transparent;
                border-left: solid 2px transparent;
            `;
        }
        return "border: solid 2px transparent;";
    }

    getRowCol(index) {
        let row = 0;
        let col = index;
        while (col >= this.pagesPerRow) {
            row++;
            col -= this.pagesPerRow;
        }
        return { row, col };
    }

    getMouseoverRowCol() {
        let firstRow = 0;
        let firstCol = this.mouseover.start;
        while (firstCol >= this.pagesPerRow) {
            firstRow++;
            firstCol -= this.pagesPerRow;
        }
        let lastRow = 0;
        let lastCol = this.mouseover.end;
        while (lastCol >= this.pagesPerRow) {
            lastRow++;
            lastCol -= this.pagesPerRow;
        }
        return { firstRow, firstCol, lastRow, lastCol };
    }

    inZone = false;

    onZoneIn() {
        this.inZone = true;
    }

    onZoneOut() {
        this.inZone = false;
    }

    removePage(index) {
        if (!this.pages[index].remove) {
            this.handlePageNotRemoved(index);
        } else {
            this.handlePageRemoved(index);
        }
        this.pages[index].remove = !this.pages[index].remove;
    }

    /**
     * Handles the scenario where a page is not removed from the document
     * @param {number} index - The index of the page that was not removed
     * If the index given is greater than the end of the last page range, it updates the end of the last page range to the index param
     * If the index is less than the start of the first page range, it increments the start of the first page range
     * Otherwise, it calls updatePageRangesForRemoval to update the page ranges
     */
    handlePageNotRemoved(index) {
        if (index > this.pageRanges[this.pageRanges.length - 1].end) {
            this.pageRanges[this.pageRanges.length - 1].end = index;
        } else if (index < this.pageRanges[0].start) {
            this.pageRanges[0].start++;
        } else {
            this.updatePageRangesForRemoval(index);
        }
    }

    /**
     * Handles the removal of a page from the document
     * @param {number} index - The index of the page that was removed
     * If the removed page index is less than the start of the first page range,
     * the start of the first page range is updated to the removed page index
     * If it doesn't, it search for the page range that starts after the removed page index
     * and increments the end of the previous page range.
     */
    handlePageRemoved(index) {
        if (index < this.pageRanges[0].start) {
            this.pageRanges[0].start = index;
        } else {
            const toAddPageIndex = this.pageRanges.findIndex((x) => x.start > index);
            if (toAddPageIndex !== -1) {
                this.pageRanges[toAddPageIndex - 1].end++;
            }
        }
    }

    updatePageRangesForRemoval(index) {
        const toRemovePagePageRangeIndex = this.pageRanges.findIndex((x) => x.end >= index);
        if (toRemovePagePageRangeIndex !== -1) {
            if (this.pageRanges[toRemovePagePageRangeIndex].end === index) {
                this.pageRanges[toRemovePagePageRangeIndex].end--;
            } else if (this.pageRanges[toRemovePagePageRangeIndex].start === index) {
                this.pageRanges[toRemovePagePageRangeIndex].start++;
            } else {
                this.split(index);
                this.pageRanges.find((x) => x.end === index).end--;
            }
        }
    }

    loaded(event) {
        this.pageCount = event._pdfInfo.numPages;
    }

    /**
     * Generates the border style for a given cell in a table.
     *
     * @param {number} row - The current row index of the cell.
     * @param {number} col - The current column index of the cell.
     * @param {number} firstRow - The index of the first row in the table.
     * @param {number} firstCol - The index of the first column in the table.
     * @param {number} lastRow - The index of the last row in the table.
     * @param {number} lastCol - The index of the last column in the table.
     * @param {boolean} hover - Indicates whether the cell is being hovered over.
     * @returns {string} The combined border style for the cell.
     * */
    getBorderStyle(row, col, firstRow, firstCol, lastRow, lastCol, hover) {
        let style = "";
        style += this.getTopBorderStyle(row, firstRow, firstCol, col);
        style += this.getRightBorderStyle(row, lastRow, lastCol, col, hover);
        style += this.getBottomBorderStyle(row, lastRow, lastCol, col);
        style += this.getLeftBorderStyle(row, firstRow, firstCol, col);
        return style;
    }

    getTopBorderStyle(row, firstRow, firstCol, col) {
        if (row === firstRow || (row === firstRow + 1 && col < firstCol)) {
            return " border-top: solid 2px #F9B12A;";
        }
        return " border-top: solid 2px transparent;";
    }

    getRightBorderStyle(row, lastRow, lastCol, col, hover) {
        if (
            (row === lastRow && col === lastCol) ||
            (row < lastRow && col === this.pagesPerRow - 1)
        ) {
            return " border-right: solid 2px #F9B12A;";
        }
        if (hover) {
            return " border-right: dotted 2px #F9B12AAA;";
        }
        return " border-right: solid 2px transparent;";
    }

    getBottomBorderStyle(row, lastRow, lastCol, col) {
        if (row === lastRow || (row === lastRow - 1 && col > lastCol)) {
            return " border-bottom: solid 2px #F9B12A;";
        }
        return " border-bottom: solid 2px transparent;";
    }

    getLeftBorderStyle(row, firstRow, firstCol, col) {
        if ((row === firstRow && col === firstCol) || (row > firstRow && col === 0)) {
            return " border-left: solid 2px #F9B12A;";
        }
        return " border-left: solid 2px transparent;";
    }

    @Watch("pageCount")
    onPageCountChange() {
        if (this.src) {
            this.loading = true;
            const pages = [];
            let pageRanges = [];
            if (this.analysis && this.analysis.pageRanges && this.analysis.pageRanges.length) {
                pageRanges = this.analysis.pageRanges.map((pr) => {
                    return {
                        start: pr.start,
                        end: pr.end,
                        type: "PURCHASE_INVOICE",
                        loaded: false,
                    };
                });
            } else {
                pageRanges = [
                    {
                        start: 0,
                        end: this.pageCount - 1,
                        type: "PURCHASE_INVOICE",
                        loaded: false,
                    },
                ];
            }
            switch (this.pageCount) {
                case 1:
                    this.pagesPerRow = 1;
                    break;
                case 2:
                    this.pagesPerRow = 2;
                    break;
                case 3:
                    this.pagesPerRow = 3;
                    break;
                default:
                    this.pagesPerRow = 4;
            }
            for (let i = 0; i < this.pageCount; i++) {
                pages.push({
                    index: i + 1,
                    display: true,
                    direction: 0,
                    remove: false,
                    hover: false,
                });
            }
            this.pages = pages;
            this.pageRanges = pageRanges;
            this.loading = false;
        }
    }
}

export default toNative(DocumentPdfSplitter);
</script>

<style lang="scss" scoped>
.hover {
    opacity: 0.3;
}

.draggable-main {
    max-height: 83vh;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
}

.draggable-col {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.draggable-col-div {
    width: 100%;
    height: 100%;
    position: relative;
}
.split {
    position: absolute;
    margin: 0 16px;
    top: calc(50% - 16px);
    right: -32px;
    z-index: 10;
}
</style>
